<template>
  <div class="blog">
    <div class="container background-container">
      <div class="row">
        <div class="col-md-12 p-0 pt-4">
          <img
            class="blog__header-image"
            src="@/assets/images/blog/cookingupcash/header.jpg"
            alt="header-image"
          />
        </div>
      </div>
    </div>

    <div class="container p-md-0">
      <div class="row">
        <div class="col-md-12 p-md-0">
          <h1 class="blog__title">
            Empowering Creators: How Found Drives Revenue and Deepens Audience
            Connections
          </h1>
        </div>
      </div>

      <div class="row position-relative">
        <div
          v-if="userAgent && !isInstagramBrowser"
          class="blog__social d-md-flex d-none"
        >
          <span class="blog__social-title">Share</span>
          <div
            v-for="(link, key) in socialLinks"
            :key="key"
            class="mt-2"
            @click="handleShareClick"
          >
            <img :src="getImageItem(key)" :alt="key" />
          </div>
        </div>
        <div class="col-md-8 offset-md-2">
          <p>
            SOCIAL media cooks who have a large following can now create cash
            for their content – with little effort on their part.
          </p>
          <p>
            Thousands of influencers have a loyal audience who love their
            recipes – making them rich in numbers but not in cash.
          </p>
          <p>
            But now thanks to a unique system, they can turn that content into
            printed assets with no outlay, with the full backing of an
            award-wining company.
          </p>
          <p>
            Found is a system where once the company is allowed access to
            digital content this can be turned into hard copy books which can
            feature favourite recipes – and then can be sold directly to
            followers.
          </p>

          <img
            class="blog__landscape-image"
            src="@/assets/images/blog/cookingupcash/1.jpg"
            alt="image"
          />

          <p>
            For the influencers it’s a win-win situation as the books are
            printed on demand, so there is no upfront monetary outlay. The
            orders are sent out directly by Found, with the creator receiving
            their percentage on every book sold going directly back to them.
          </p>
          <p>
            The ordering process sits on the Found website, so the influencer
            doesn’t even need a website to benefit.
          </p>
          <p>
            At the same time anyone who signs up with Found also benefits from a
            support PR and marketing package to help them raise their profile
            and build their followers.
          </p>
          <p>
            Found was created by entrepreneur Nigel Watson and Louise
            Stephenson, Managing Director of Found, said influencers in both the
            UK and USA are already seeing great results.
          </p>
          <p>
            “Creating content gives people an asset that a lot of them don’t
            realise they can moneterise,” she said,
          </p>
          <p>
            “There are hundreds of home cooks and chefs sharing their recipes on
            Tik Tok, Facebook and Instagram which are gaining them followers but
            not making them any money.
          </p>
          <p>
            “This is a fantastic, no risk, way of them being able to use their
            assets for their financial benefit and the more they promote their
            books to their followers, the more money they are likely to make.”
          </p>
        </div>

        <div class="col-md-8 offset-md-2">
          <div class="blog__double-image">
            <img src="@/assets/images/blog/cookingupcash/3.jpg" alt="image" />
            <img src="@/assets/images/blog/cookingupcash/4.jpg" alt="image" />
          </div>
        </div>

        <div class="col-md-8 offset-md-2 mt-3">
          <p>
            One influencer who has already benefited is Caroline Davis, aka
            Mississippi Kween, who has more than 1.4m followers who watch her
            southern cooking videos on Tik Tok and Instagram.
          </p>

          <p>
            She has sold more than 12,000 copies of her first cookery book and
            has thousands of pre-orders for her second.
          </p>

          <p>“It’s been absolutely amazing for me,” she said.</p>

          <div class="blog__quote my-5">
            <p>
              “All I’ve had to do is promote the books to my followers to help
              generate sales at no cost to me at all.”
            </p>
          </div>

          <p>
            Louise Stephenson said that “our state-of-the-art technology means
            that the process can be really fast, and we aim to get the books
            live within four weeks, where as a publisher would take months to do
            this.”
          </p>

          <img
            class="blog__landscape-image"
            src="@/assets/images/blog/cookingupcash/2.jpg"
            alt="image"
          />

          <p>
            Found has also recently just extended its offering to cover
            merchandise, allowing influencers to create branded products such as
            aprons which again can help grow both their audience and their cash.
          </p>

          <p>
            To eligible for Found influencers need to have at least 50 recipes
            across their social platforms and must also be willing to help with
            the marketing of the books, by promoting it to their audience.
          </p>

          <p>
            The company is also looking to work with up-and-coming content
            creators to help them grow their profile and so can benefit from
            everything Found has to offer.
          </p>

          <p>
            The plan is to extend the offering in the near future to include
            influencers who are also working in the fields of health and
            beauty/wellbeing.
          </p>

          <p>
            “It may sound too good to be true, but we’ve already got clients who
            are doing really well out of this process,” said Louise. “And we
            hope that more of them will now realise that they are sitting on an
            untapped source of revenue.”
          </p>

          <div
            v-if="userAgent && !isInstagramBrowser"
            class="blog__social d-md-none"
          >
            <span class="blog__social-title">Share</span>
            <div class="d-flex">
              <div
                v-for="(link, key) in socialLinks"
                :key="key"
                class="mt-2 mr-md-0 mr-3"
                @click="handleShareClick"
              >
                <img :src="getImageItem(key)" :alt="key" />
              </div>
            </div>
          </div>

          <div v-if="tags && tags.length">
            <h2 class="mt-4">Related topics</h2>
            <div class="blog__tags">
              <Tag
                v-for="tag in tags"
                :key="tag"
                class="mr-3 my-2"
                @click="onTagClick(tag)"
              >
                {{ tag }}
              </Tag>
            </div>
          </div>

          <div class="blog__action-button mt-5">
            <Button
              class="pt-2"
              full-width
              size="sm"
              @click="handleBeFoundClick"
            >
              I’m ready to talk
            </Button>
          </div>

          <Carousel
            v-if="creatorProducts && creatorProducts.length"
            id="blog-products"
            class="my-4"
            :items="creatorProducts"
            :mode="CarouselModes.PRODUCT"
            show-default-item-actions
            @click="handleProductBundleClick"
          >
            <template #title>
              <h2>More from {{ creatorHandle }}</h2>
            </template>
          </Carousel>

          <div class="blog__action-button mt-3 mb-5">
            <Button
              class="pt-2"
              full-width
              size="sm"
              variant="outline"
              @click="$router.push('/blog')"
            >
              View all blogs
            </Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { throttle } from 'lodash';
import socialLinks from '@/misc/socialLinks';
import { CarouselModes, WebApiCancelError } from '@/misc/constants';
import Tag from '@/components/Elements/Tag.vue';
import Button from '@/components/Elements/Button.vue';
import getDefaultProductFormat from '@/misc/getDefaultProductFormat';
import formatMoney from '@/misc/formatMoney';
import getFormatPrice from '@/misc/getFormatPrice';
import { fetchProductsByCreator } from '@/services/products';
import filterProductsByRegion from '@/misc/filterProductByRegion';

export default {
  name: 'BlogItemPage',
  components: {
    Button,
    Tag,
    Carousel: () =>
      import(/* webpackPrefetch: true */ '@/components/Carousel/Index')
  },

  data() {
    return {
      creatorHandle: 'mississippi_kween',
      CarouselModes,
      socialLinks,
      creatorProducts: [],
      tags: ['General']
    };
  },

  head: {
    title: 'Be Found | Blog'
  },

  computed: {
    ...mapState('main', ['userAgent']),
    ...mapGetters({
      isInstagramBrowser: 'main/isInstagramBrowser',
      currency: 'config/currency',
      region: 'config/region'
    })
  },

  mounted() {
    fetchProductsByCreator(this.$axios, this.creatorHandle)
      .then((response) => {
        const creatorProducts = this.$get(response, 'creatorProducts');
        this.creatorProducts = filterProductsByRegion(
          creatorProducts,
          this.region
        );
        this.contributedProducts = filterProductsByRegion(
          this.$get(response, 'contributedProducts'),
          this.region
        );
      })
      .catch((err) => {
        this.$showToastMessage(
          this.$get(err, 'response.data.message'),
          'Error',
          'danger'
        );
      });
  },

  methods: {
    getImageItem(key) {
      return require(`@/assets/icons/social/${key}.svg`);
    },

    onTagClick(tag) {
      this.$router.push('/blog?filter=' + tag);
    },

    handleBeFoundClick() {
      this.$router.push({ path: '/be-found' });
    },

    handleShareClick: throttle(function () {
      const url = window.location.href;
      if (navigator?.share) {
        navigator.share({ url }).catch((err) => {
          if (!err.message.includes(WebApiCancelError)) {
            this.$showToastMessage(err.message, 'Error', 'error');
          }
        });
      } else if (navigator?.clipboard) {
        navigator.clipboard
          .writeText(url)
          .then(() =>
            this.$showToastMessage('Link is copied', 'Success', 'success')
          )
          .catch((err) =>
            this.$showToastMessage(
              `Failed to copied link ${err.message}`,
              'Error',
              'error'
            )
          );
      } else {
        this.$showToastMessage(
          `Sharing function is not supported`,
          'Error',
          'error'
        );
      }
    }, 1500),

    getProductFormatPrice(product) {
      const defaultFormat = getDefaultProductFormat(product);
      return formatMoney(
        getFormatPrice(defaultFormat, this.region)?.amount,
        this.currency
      );
    },

    handleProductBundleClick(product) {
      this.$router.push({
        path: `/products/${product.id || product.item.id}`
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.blog {
  &__header-image {
    object-fit: cover;
    height: 480px;
    width: 100%;
  }

  &__title {
    padding-top: 40px;
    text-align: left;
    line-height: 56px;
  }

  &__landscape-image {
    object-fit: cover;
    transform: translate3d(0, 0, 1px);
    height: 550px;
    width: 100%;
    margin-bottom: 40px;
  }

  &__social {
    position: absolute;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    text-align: center;

    &-title {
      font-size: 12px;
    }
  }

  &__double-image {
    display: flex;
    justify-content: space-around;

    img {
      object-fit: cover;
      height: 700px;
      &:first-child {
        margin-right: 20px;
      }
    }
  }

  &__quote {
    font-family: 'Poppins-SemiBold', sans-serif;
    font-size: 24px;
    border-left: 8px solid $primary-color;
    padding-left: 35px;
  }

  &__action-button {
    margin: 0 auto;
    max-width: 240px;
  }

  @media (max-width: $screen-width-md) {
    &__header-image {
      object-fit: contain;
      height: 242px;
    }

    &__landscape-image {
      height: 328px;
    }

    &__double-image {
      flex-wrap: wrap;

      img {
        margin-bottom: 25px;
        object-fit: cover;
        height: 420px;
        &:first-child {
          margin-right: 0;
        }
      }
    }

    &__social {
      position: initial;
      flex-direction: column;
      text-align: left;
    }
  }
}
</style>
